import { Helmet } from 'react-helmet-async';
import React from 'react';
import { Alert } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import ResetPasswordFormContainer from '../containers/auth/ResetPasswordFormContainer.jsx';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const resetPasswordToken = searchParams.get('reset_password_token');

  return (
    <div className="component-centered">
      <Helmet>
        <title>ChangeSync</title>
      </Helmet>
      {resetPasswordToken ? (
        <ResetPasswordFormContainer resetPasswordToken={resetPasswordToken} />
      ) : (
        <Alert bsStyle="danger">
          <h4 className="component-sm-margin-bottom">
            Missing password reset token
          </h4>
          Please click the link from the last password reset email you received
          to reset your password.
        </Alert>
      )}
    </div>
  );
}

export default ResetPassword;
